(() => {
class GhCountdownTimer extends HTMLElement {
  connectedCallback() {
    this.start();
  }
  getTargetDate() {
    const y = this.getAttribute("data-year");
    const m = this.getAttribute("data-month");
    const d = this.getAttribute("data-day");
    const h = this.getAttribute("data-hour") || "00";
    const min = this.getAttribute("data-minute") || "00";
    if (!y || !m || !d) return new Date();
    return new Date(`${m}/${d}/${y} ${h}:${min}:00`);
  }
  getEl(cls) {
    if (!cls) return null;
    return this.querySelector(`.${cls}`);
  }
  format(n) {
    return n < 10 ? `0${n}` : `${n}`;
  }
  updateLabels(days, hours, mins, secs) {
    const usePlural = this.getAttribute("data-pluralize") === "true";
    if (!usePlural) return;

    const map = [
      ["days", days],
      ["hours", hours],
      ["minutes", mins],
      ["seconds", secs],
    ];
    for (const [key, val] of map) {
      const singular = this.getAttribute(`data-${key}-singular`);
      const plural = this.getAttribute(`data-${key}-plural`);
      const labelCls = this.getAttribute(`data-${key}-label-class`);
      const el = this.getEl(labelCls);
      
      if (!el) continue;
      
      if (singular && plural) {
        el.textContent = val === 1 ? singular : plural;
        continue;
      }
      const ds = typeof theme !== "undefined" && theme.dateStrings ? theme.dateStrings : null;
      if (!ds) continue;
      let s = "";
      let p = "";
      if (key === "days") {
        s = ds.day;
        p = ds.days;
      } else if (key === "hours") {
        s = ds.hour;
        p = ds.hours;
      } else if (key === "minutes") {
        s = ds.minute;
        p = ds.minutes;
      } else if (key === "seconds") {
        s = ds.second;
        p = ds.seconds;
      }
      if (s && p) {
        el.textContent = val === 1 ? s : p;
      }
    }
  }
  tick() {
    const now = new Date();
    const target = this.targetDate || this.getTargetDate();
    const diff = target - now;
    if (diff <= 0) {
      this.finish();
      return;
    }
    const dayMs = 24 * 60 * 60 * 1000;
    const hourMs = 60 * 60 * 1000;
    const days = Math.floor(diff / dayMs);
    const hours = Math.floor((diff % dayMs) / hourMs);
    const mins = Math.floor((diff % hourMs) / (60 * 1000));
    const secs = Math.floor((diff % (60 * 1000)) / 1000);
    const map = [
      ["days", days],
      ["hours", hours],
      ["minutes", mins],
      ["seconds", secs],
    ];
    let hideHandle = true;
    for (const [key, val] of map) {
      const hiddenEl = this.getAttribute(`data-end-${key}-hidden`);
      if(val == 0 && hideHandle && hiddenEl == 'true') {
        this.endHideDom(key, val);
      }else{
        hideHandle = false;
      }
      const cls = this.getAttribute(`data-${key}-value-class`);
      const el = this.getEl(cls);
      if (el) el.textContent = this.format(val);
    }
    this.updateLabels(days, hours, mins, secs);
  }
  endHideDom(key, val) {
    if(val == 0){
      const cls = this.getAttribute('data-countdown-class');
      if(cls) {
        const el = this.querySelectorAll(`.${cls}-${key}`);
        if(el) {
          el.forEach && el.forEach(dom => {
            dom.style.display = 'none';
          });
        }
      }
    }
  }
  start() {
    this.targetDate = this.getTargetDate();
    this.tick();
    this.timer = setInterval(() => this.tick(), 1000);
  }
  finish() {
    if (this.timer) clearInterval(this.timer);
    const action = this.getAttribute("data-end-action") || "none";
    const hidden = this.getAttribute("data-end-hide") || "none";
    if (action === "hide") {
      const selector = this.getAttribute("data-end-hide-selector");
      const el = selector ? document.querySelector(selector) : this;
      if (el) el.style.display = "none";
    } else if (action === "text") {
      const selector = this.getAttribute("data-end-text-selector");
      const text = this.getAttribute("data-ended-text") || "";
      if (selector) {
        const el = document.querySelector(selector);
        if (el) el.innerHTML = text;
      }
      if(hidden) {
        this.style.display = 'none';
      }
    }
    this.dispatchEvent(
      new CustomEvent("countdown-ended", { detail: { element: this }, bubbles: true })
    );
  }
}
if(!customElements.get("gh-countdown-timer")) {
  customElements.define("gh-countdown-timer", GhCountdownTimer);
}
})();
